import React from 'react';

import { WrapperBanner } from './styles';
import { BodyTextMediumC } from '@/shared/ui/typography2';
import { Button } from '@/shared/ui/form/button';
import { Box } from '@/shared/ui/box';
import { useI18n } from '@locales/client';
import { useRouter } from 'next-nprogress-bar';
import { useConfirmDataPrompt } from '@/features/data-managment/model/hooks';

const BannerPrompts = () => {
  const { showBanner, role, onPopupShow } = useConfirmDataPrompt();
  const router = useRouter();
  const t = useI18n();

  const handleClick = () => {
    onPopupShow();
  };

  return (
    showBanner &&
    role !== 'player' && (
      <WrapperBanner>
        <BodyTextMediumC>
          {t('account_verification.accountDataVerification')}
        </BodyTextMediumC>
        <Box>
          <Button onClick={handleClick} variant="orangeGradient">
            <BodyTextMediumC>
              {t('account_verification.confirm')}
            </BodyTextMediumC>
          </Button>
        </Box>
      </WrapperBanner>
    )
  );
};

export { BannerPrompts };
